export default __webpack_public_path__ + "1722fbac6f6b0688a5da32a81fd098e4.svg";